var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.permissions.hasRead
    ? _c(
        "div",
        [
          _c("app-detail-header", {
            attrs: {
              "show-toggle": true,
              "show-delete": false,
              "show-save": false,
              "show-cancel": false,
              "show-print": false,
            },
            on: { appDetailHeaderButtonClicked: _vm.onHeaderButtonClicked },
          }),
          _c("div", { staticClass: "columns is-gapless" }, [
            _c(
              "div",
              { staticClass: "column is-narrow" },
              [
                _c("quote-template-list-side-menu", {
                  attrs: {
                    tags: _vm.tags,
                    "tag-category-id": _vm.tagCategory.tagCategoryID,
                  },
                  on: { filter: _vm.filterList, reset: _vm.resetFilter },
                  model: {
                    value: _vm.filter,
                    callback: function ($$v) {
                      _vm.filter = $$v
                    },
                    expression: "filter",
                  },
                }),
              ],
              1
            ),
            _c("div", { staticClass: "column" }, [
              _c("div", { staticClass: "m-3" }, [
                _c(
                  "article",
                  { staticClass: "box" },
                  [
                    _c(
                      "bulma-table",
                      {
                        staticClass:
                          "table is-bordered is-striped is-narrow is-fullwidth",
                        attrs: {
                          columns: _vm.columns,
                          "is-loading": _vm.isTableLoading,
                          "page-index": _vm.filter.pageIndex,
                          "page-size": _vm.filter.pageSize,
                          "sort-column": _vm.filter.sortColumn,
                          "sort-order": _vm.filter.sortOrder,
                          "total-rows": _vm.totalRows,
                        },
                        on: { pageChanged: _vm.onPageChange, sort: _vm.sort },
                      },
                      [
                        _vm._l(_vm.templates, function (template, index) {
                          return _c("tr", { key: index }, [
                            _c(
                              "td",
                              { staticClass: "is-uppercase" },
                              [
                                _c(
                                  "router-link",
                                  {
                                    attrs: {
                                      to: { path: template.templateId },
                                      append: "",
                                    },
                                  },
                                  [_vm._v(" " + _vm._s(template.name) + " ")]
                                ),
                              ],
                              1
                            ),
                            _c("td", [
                              _vm._v(
                                _vm._s(
                                  _vm.quoteTemplateTypes[template.quoteType]
                                )
                              ),
                            ]),
                            _c("td", [
                              _vm._v(
                                _vm._s(
                                  template.createdDate
                                    ? _vm.$filters.formatDateTimezone(
                                        `${template.createdDate}Z`,
                                        _vm.$userInfo.locale
                                      )
                                    : ""
                                )
                              ),
                            ]),
                            _c("td", [_vm._v(_vm._s(template.timesType))]),
                            _c(
                              "td",
                              _vm._l(template.tags, function (tag) {
                                return _c(
                                  "span",
                                  {
                                    key: tag.tagID,
                                    staticClass: "tag mr-2",
                                    class: `is-${_vm.$theme.name}`,
                                    style: {
                                      backgroundColor: tag.colorHex,
                                      color: _vm.getTextColor(tag.colorHex),
                                      borderRadius: "9999px",
                                      fontWeight: "bold",
                                    },
                                  },
                                  [_vm._v(" " + _vm._s(tag.shortTag) + " ")]
                                )
                              }),
                              0
                            ),
                            _c(
                              "td",
                              {
                                staticClass: "has-text-centered action-column",
                              },
                              [
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "button is-primary is-small is-inverted tooltip",
                                    attrs: { "data-tooltip": "Click to edit" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.editTemplate(template)
                                      },
                                    },
                                  },
                                  [
                                    _c("span", { staticClass: "icon" }, [
                                      _c("i", {
                                        staticClass:
                                          "mdi mdi-lead-pencil mdi-24px",
                                      }),
                                    ]),
                                  ]
                                ),
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "button is-danger is-small is-inverted",
                                    class: {
                                      tooltip: !_vm.permissions.hasDelete,
                                    },
                                    attrs: {
                                      disabled: !_vm.permissions.hasDelete,
                                      "data-tooltip": [
                                        !_vm.permissions.hasDelete
                                          ? "No Permission"
                                          : "",
                                      ],
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.activeConfirmDeleteModal(
                                          template
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "icon is-medium" },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "mdi mdi-delete mdi-24px",
                                        }),
                                      ]
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ])
                        }),
                        _c("template", { slot: "empty" }, [
                          _c("section", { staticClass: "section" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "content has-text-grey has-text-centered",
                              },
                              [
                                _c(
                                  "span",
                                  { attrs: { icon: "icon is-large" } },
                                  [
                                    _c("i", {
                                      staticClass:
                                        "mdi mdi-48px mdi-emoticon-sad",
                                    }),
                                  ]
                                ),
                                _c("p", [_vm._v("Nothing")]),
                              ]
                            ),
                          ]),
                        ]),
                      ],
                      2
                    ),
                    _vm.isNewTemplateModalActive
                      ? _c(
                          "quote-new-template-modal",
                          {
                            attrs: {
                              active: _vm.isNewTemplateModalActive,
                              templates: _vm.templates,
                              tags: _vm.tags,
                              "tag-category-id": _vm.tagCategory.tagCategoryID,
                            },
                            on: {
                              "update:active": function ($event) {
                                _vm.isNewTemplateModalActive = $event
                              },
                              "update:templates": function ($event) {
                                _vm.templates = $event
                              },
                            },
                          },
                          [
                            _c(
                              "p",
                              {
                                attrs: { slot: "text-title" },
                                slot: "text-title",
                              },
                              [_vm._v("Create a new template")]
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm.templateDeleted
                      ? _c(
                          "confirm-modal",
                          {
                            attrs: {
                              active: _vm.isConfirmModalActive,
                              "ok-text": "Yes",
                              "cancel-text": "No",
                            },
                            on: {
                              "update:active": function ($event) {
                                _vm.isConfirmModalActive = $event
                              },
                              ok: function ($event) {
                                return _vm.deleteTemplate(true)
                              },
                              cancel: function ($event) {
                                return _vm.deleteTemplate(false)
                              },
                            },
                          },
                          [
                            _c(
                              "p",
                              {
                                attrs: { slot: "text-title" },
                                slot: "text-title",
                              },
                              [_vm._v("Delete Quote Template")]
                            ),
                            _c(
                              "p",
                              {
                                staticClass: "has-text-danger",
                                attrs: { slot: "text-content" },
                                slot: "text-content",
                              },
                              [
                                _vm._v(" Quote Template "),
                                _c(
                                  "span",
                                  { staticClass: "has-text-weight-bold" },
                                  [_vm._v(_vm._s(_vm.templateDeleted.name))]
                                ),
                                _vm._v(" will be deleted. Continue? "),
                              ]
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm.isEditModalActive
                      ? _c(
                          "quote-template-edit-modal",
                          {
                            attrs: {
                              active: _vm.isEditModalActive,
                              template: _vm.templateUpdated,
                              templates: _vm.templates,
                              tags: _vm.tags,
                              "tag-category-id": _vm.tagCategory.tagCategoryID,
                            },
                            on: {
                              "update:active": function ($event) {
                                _vm.isEditModalActive = $event
                              },
                              "update:template": function ($event) {
                                _vm.templateUpdated = $event
                              },
                              "update:templates": function ($event) {
                                _vm.templates = $event
                              },
                            },
                          },
                          [
                            _c(
                              "p",
                              {
                                attrs: { slot: "text-title" },
                                slot: "text-title",
                              },
                              [
                                _vm._v(
                                  "Edit Template " +
                                    _vm._s(_vm.templateUpdated.name)
                                ),
                              ]
                            ),
                          ]
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ]),
            ]),
          ]),
        ],
        1
      )
    : _c("div", [_vm._m(0)])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "is-flex is-justify-content-center pt-5" },
      [
        _c("div", { staticClass: "notification is-danger is-flex is-size-4" }, [
          _vm._v(" You do not have permissions on this page "),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }